"use client";

import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "@/store";
import { useAuth } from "@/context/AuthContext";
import {
  fetchEvolutionStatus,
  connectEvolution,
  deleteEvolution,
} from "@/store/modules/evolution/thunks";

const useEvolution = () => {
  const dispatch: AppDispatch = useDispatch();
  const { establishment, baseURL } = useAuth();

  const { status, loading, error } = useSelector(
    (state: any) => state.evolution,
  );

  const refreshStatus = useCallback(async () => {
    if (!establishment || !baseURL) return;

    await dispatch(fetchEvolutionStatus(String(establishment.id)));
  }, [dispatch, establishment, baseURL]);

  const connect = useCallback(
    async (opts?: { force?: boolean; name?: string }) => {
      if (!establishment || !baseURL) return;
      return await dispatch(
        connectEvolution({
          establishmentId: String(establishment.id),
          ...(opts || {}),
        }),
      );
    },
    [dispatch, establishment, baseURL],
  );

  const remove = useCallback(async () => {
    if (!establishment || !baseURL) return;
    return await dispatch(deleteEvolution(String(establishment.id)));
  }, [dispatch, establishment, baseURL]);

  useEffect(() => {
    // auto-fetch when establishment/baseURL ready
    if (!establishment || !baseURL) return;
    dispatch(fetchEvolutionStatus(String(establishment.id)));
  }, [dispatch, establishment, baseURL]);

  return {
    status,
    loading,
    error,
    refreshStatus,
    connect,
    remove,
  };
};

export default useEvolution;
